import React from 'react';
import TerminosCondiciones from '../../TerminosCondiciones';
import './historial.css'
import useResizeEventIframe from '../../Utils/Iframe';

class Historial extends React.Component {

    constructor(props) {
        super(props);
        this.state = { historial: [], aceptoTerminos: false };
        this.ref = React.createRef();
    }

    componentDidMount() {
        this.obtieneHistorial();
    }

    obtieneHistorial() {
        fetch(process.env.REACT_APP_URL_DTO_BACK + "historial", {
            method: "GET",
            headers: {
                "Authorization": "Bearer " + this.props.servicio.getToken()
            }
        }).then(async res => {
            let responseBody = await res.json();
            if (res.status < 299) {
                this.setState({ historial: responseBody.mensaje })
            } else {
                this.setState({ historial: [] });
            }
        }).catch(errorP => {
            console.log(errorP);
        });
    }

    handleClose = () => {
        if (this.props.marca === "vw" && this.props.location.pathname.startsWith("/es/app/sigue-tu-volkswagen/vw/")!==true)
            window.location = "/app/sigue-tu-volkswagen/vw/inicio"
        else if(this.props.marca === "vw" && this.props.location.pathname.includes("/es/app/sigue-tu-volkswagen/vw/")===true)
            window.location = "/es/app/sigue-tu-volkswagen/vw/inicio.html"
        else
            window.location = "/" + this.props.marca + "/inicio";
    }

    setAceptoTerminos = (callback) => {
        this.setState({ aceptoTerminos: callback });
    }

    render() {
        let SetResizeIframe = () => { useResizeEventIframe(this.ref); return null };
        return (
            <div ref={this.ref}>
                {this.props.marca === 'audi' && <SetResizeIframe />}
                {this.state.aceptoTerminos === false ?
                    <TerminosCondiciones marca={this.props.marca} servicio={this.props.servicio} servicioFirebase={this.props.servicioFirebase} callbackAceptoTerminos={this.setAceptoTerminos} mostrarMenu={this.props.marca !== 'vw'} mostrarFooter={this.props.marca !== 'vw'} />
                    :
                    <div className={"container__font--" + this.props.marca}>
                        <div className="container">

                            <div className={"col col-md-8 offset-md-2 pt-5 pb-5 margin__top--titulo"}>
                                <div>
                                    <h2>Historial de Guías</h2>
                                </div>
                                <p className={this.props.marca}>Aquí puedes revisar tus guías de compra anteriores.</p>

                                <div className="div_scroll audiScroll" >
                                    <div className={this.state.historial.length > 0 ? "d-none" : ""} >
                                        <p className={this.props.marca}>Aún no has completado una compra.</p>
                                    </div>
                                    {
                                        this.state.historial.map((compra, i) => {
                                            return <div key={i} > <div key={i} className="col">
                                                <div className={"style_" + this.props.marca}>
                                                    <h4 id="lblModeloAuto">{compra.modeloInteres}</h4>
                                                    <h5 id="lblFechaentrega" className="fechaEntrega">{compra.fechaEntrega !== null ? "Entregado el " + compra.fechaEntrega : "Lo sentimos esta compra no fue completada."}</h5>
                                                    <h6 className="idEntrega">{compra.idCompra}</h6>
                                                </div>
                                            </div><br /></div>
                                        })
                                    }
                                </div>
                                <br></br>
                                <br></br>
                                <div className="col-xs-12 mt-3">
                                    <div className="button">
                                        <button className={"w-100 form__button--" + this.props.marca + "-black form__button--" + this.props.marca} name="consultar" onClick={this.handleClose}>Regresar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}
export default Historial;